import { RubricLevelType, RubricType } from "components/server-types";

export const RUBRIC_FIELDS_TO_COMPARE = ["name", "conversion_percent", "description"] as const;

export type ComparableRubricField = (typeof RUBRIC_FIELDS_TO_COMPARE)[number];

export function getRubricLevelsByScore(rubric: RubricType) {
  return new Map(rubric.map((rubricLevel) => [rubricLevel.score, rubricLevel]));
}

export function rubricFieldDiffers(
  rubricLevel: RubricLevelType,
  comparisonRubricLevelsByScore: Map<number, RubricLevelType>,
  rubricField: ComparableRubricField,
) {
  return (
    rubricLevel[rubricField] !== comparisonRubricLevelsByScore.get(rubricLevel.score)?.[rubricField]
  );
}

export function countDifferentRubricFields(
  destinationRubric: RubricType,
  sourceRubric: RubricType,
) {
  const destinationRubricLevelsByScore = getRubricLevelsByScore(destinationRubric);
  const sourceRubricLevelsByScore = getRubricLevelsByScore(sourceRubric);
  const allScores = new Set([
    ...destinationRubricLevelsByScore.keys(),
    ...sourceRubricLevelsByScore.keys(),
  ]);

  return [...allScores].reduce(
    (differentRubricFieldCount, score) =>
      differentRubricFieldCount +
      RUBRIC_FIELDS_TO_COMPARE.filter(
        (rubricField) =>
          destinationRubricLevelsByScore.get(score)?.[rubricField] !==
          sourceRubricLevelsByScore.get(score)?.[rubricField],
      ).length,
    0,
  );
}
